import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-business-days';
import { loadSuggestions } from 'actionCreators';
import AssessmentSuggestionsList from 'assessmentSuggestionsList';
import Loading from 'components/Loading';
import ScheduleType from 'types/schedule';
import { groupSuggestionsByPage } from '../../../../../utils/schedulingUtils';
import { SCHEDULE_DATE } from 'config/constants';
import S from './suggestions.scss';

class AssessmentSuggestions extends Component {
  constructor(props) {
    super(props);
    const { date: queryStart } = this.props;
    this.state = { queryStart };
    this.getSuggestions = this.getSuggestions.bind(this);
    this.handleQueryStartChange = this.handleQueryStartChange.bind(this);
  }

  componentDidMount = () => this.getSuggestions();

  getSuggestions = (persist = false) => {
    const { queryStart } = this.state;
    const { phaseId, phaseType, isCcs } = this.props;
    const start = moment(queryStart, SCHEDULE_DATE).toDate() || new Date();
    if (!persist) this.props.clearAssessmentSuggestion();
    this.props.loadSuggestions(phaseId, phaseType, start, isCcs);
  }

  handleQueryStartChange = date => this.setState({ queryStart: date });

  render = () => {
    const { onSelect, zone, suggestionKey, handleSubmit, isCcs, handleShowAssessmentSuggestions,
            errors, isAfternoon, schedule: { loading = true, suggestions } } = this.props;
    const { queryStart } = this.state;
    const totalCount = suggestions.length;
    return (loading ? (<Loading className={S.spinner} />) : (<Fragment>
      <AssessmentSuggestionsList
        isCcs={isCcs}
        suggestions={totalCount ? groupSuggestionsByPage(suggestions) : [[]]}
        totalCount={totalCount}
        zone={zone}
        suggestionKey={suggestionKey}
        queryStart={queryStart}
        handleSelect={v => onSelect(v, 'assessment')}
        handleSubmit={handleSubmit}
        handleQueryStartChange={this.handleQueryStartChange}
        handleShowAssessmentSuggestions={handleShowAssessmentSuggestions}
        rerunLoadSuggestions={this.getSuggestions}
        isAfternoon={isAfternoon}
        errors={errors}
      />
    </Fragment>));
  }
}

AssessmentSuggestions.propTypes = {
  isCcs: PropTypes.bool,
  zone: PropTypes.string,
  loadSuggestions: PropTypes.func.isRequired,
  schedule: ScheduleType.isRequired,
  date: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  phaseId: PropTypes.number,
  phaseType: PropTypes.string,
  suggestionKey: PropTypes.string,
  handleShowAssessmentSuggestions: PropTypes.func,
  clearAssessmentSuggestion: PropTypes.func,
  isAfternoon: PropTypes.bool,
  errors: PropTypes.object,
};

AssessmentSuggestions.defaultProps = { date: new Date() };

export default connect(state => ({ schedule: state.schedule }),
  { loadSuggestions })(AssessmentSuggestions);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/assessmentSuggestions.jsx